import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import Model from "../Model";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Config, { dueTypes } from "../../Config";
import { Select, MenuItem } from "@mui/material";
const EditDuesModel = ({
  editDuesMutate,
  editEntryLoading,
  setEditDues,
  selectedData,
}) => {
  const SubmitHandler = (values) => {
    if (!values.balance) {
      toast.error("Please enter due balance");
      return;
    }
    editDuesMutate(values);
  };

  const formik = useFormik({
    initialValues: {
      id: selectedData?.id || "",
      balance: selectedData?.balance || "",
      // type: selectedData?.type || "",
      tenantId: selectedData?.tenantId || "",
      ledgerReferenceId: selectedData?.ledgerReferenceId || "",
      clientId: selectedData?.clientId || "",
      dueType: selectedData?.type || ""
    },

    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  return (
    <Model width={`w-11/12 max-w-md`} setOpenModel={setEditDues}>
      {editEntryLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>Edit Dues</Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>
              <InputGroup>
                <Label htmlFor="balance">Balance</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="balance"
                    id="balance"
                    autoComplete="off"
                    className="truncate"
                    required
                    value={formik.values.balance}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      if (value.length <= 7) {
                        // Limits the length to 7 digits
                        formik.setFieldValue("balance", value);
                      }
                    }}
                  />
                </FieldWrapper>
              </InputGroup>
              {/* <InputGroup>
                <Label htmlFor="dueType">Due Type</Label>
                <FieldWrapper>
                  <Select
                    name="dueType"
                    id="dueType"
                    value={formik.values.dueType}
                    onChange={formik.handleChange}
                    className="w-full pl-2"
                    style={{ height: "40px" }}
                  >
                    {dueTypes.map((type) => (
                      <MenuItem key={type.value} value={type.value}>
                        {type.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {formik.touched.dueType && formik.errors.dueType ? (
                    <p className="text-rose-600 text-sm">
                      {formik.errors.dueType}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup> */}
            </Wrapper>

            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default EditDuesModel;
